<span *ngIf="params.column.colId == 'por'" [ngClass]="{'textRed': isErrorExist, 'textUnderlined':isErrorHigh && isPageEfileSearchResult }">{{params.value}}
</span>

<span *ngIf="params.column.colId == 'euPrice'" [ngClass]="{'textRed': isErrorExist, 'textUnderlined':isErrorHigh && isPageEfileSearchResult }">{{params.euValue}}
</span>